import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsComponent } from './forms.component';

 const routes: Routes = [{
	path: '',
	data: {
		title: 'Formulario',
		status: false,
		breadcrumb: "Formulario"
	},
	children: [
		{
			path: '',
			component: FormsComponent
		}
	]
}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class FormsRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/components/forms/forms-routing.module.ts